module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/3-off-8406dc15d93e16151968b8abef8b6521.png";